import { availableGames } from '../../../mixins/games.commons';
import { Status } from '../../shared/status.model';

export const mutations = {
  SELECT_GAME: (state, { gameName }) => {
    state.statistics.selectedGame = gameName;
  },

  SET_PROFILE_DISPLAYNAME: (state, { displayname }) => {
    state.displayname = displayname;
  },

  GET_GAME_STATS: (state, { game, profileKey = 'current' }) => {
    state.profileStatusMap.statistics[game][profileKey].getAllStats = new Status({ loading: true });
  },

  GET_GAME_STATS_SUCCESS: (state, { game, gameStats, profileKey = 'current' }) => {
    state.statistics[game][profileKey] = gameStats;
    state.profileStatusMap.statistics[game][profileKey].getAllStats = new Status();
  },

  GET_GAME_STATS_FAILURE: (state, { game, error, profileKey = 'current' }) => {
    state.profileStatusMap.statistics[game][profileKey].getAllStats = new Status({ error });
  },

  GET_CONNECTED_GAMES: (state) => {
    state.profileStatusMap.getConnectedGames = new Status({ loading: true });
  },

  GET_CONNECTED_GAMES_SUCCESS: (state, { gameList }) => {
    state.gameList = gameList;
    state.profileStatusMap.getConnectedGames = new Status();
  },

  GET_CONNECTED_GAMES_FAILURE: (state, { error }) => {
    state.profileStatusMap.getConnectedGames = new Status({ error });
  },

  GET_GENERAL_STATS: (state, { game, profileKey = 'current' }) => {
    state.profileStatusMap.statistics[game][profileKey].getGeneralStats = new Status({ loading: true });
  },

  GET_GENERAL_STATS_SUCCESS: (state, { generalStats, game, profileKey = 'current' }) => {
    state.statistics[game][profileKey].general = generalStats;
    state.statistics[game][profileKey].queues = generalStats.queues;
    state.profileStatusMap.statistics[game][profileKey].getGeneralStats = new Status();
  },

  GET_GENERAL_STATS_FAILURE: (state, { error, game, profileKey = 'current' }) => {
    state.profileStatusMap.statistics[game][profileKey].getGeneralStats = new Status({ error });
  },

  GET_RANK_STATS: (state, { game, profileKey = 'current' }) => {
    state.profileStatusMap.statistics[game][profileKey].getRankStats = new Status({ loading: true });
  },

  GET_RANK_STATS_SUCCESS: (state, { rankStats, game, profileKey = 'current' }) => {
    state.statistics[game][profileKey].rank = rankStats;
    state.profileStatusMap.statistics[game][profileKey].getRankStats = new Status();
  },

  GET_RANK_STATS_FAILURE: (state, { error, game, profileKey = 'current' }) => {
    state.profileStatusMap.statistics[game][profileKey].getRankStats = new Status({ error });
  },

  GET_ACTIVITY_STATS: (state, { game, profileKey = 'current' }) => {
    state.profileStatusMap.statistics[game][profileKey].getActivityStats = new Status({ loading: true });
  },

  GET_ACTIVITY_STATS_SUCCESS: (state, { activityStats, game, profileKey = 'current' }) => {
    state.statistics[game][profileKey].activity = activityStats;
    state.statistics[game][profileKey].rankProgression = activityStats.rankProgression;
    state.profileStatusMap.statistics[game][profileKey].getActivityStats = new Status();
  },

  GET_ACTIVITY_STATS_FAILURE: (state, { error, game, profileKey = 'current' }) => {
    state.profileStatusMap.statistics[game][profileKey].getActivityStats = new Status({ error });
  },

  GET_STAT: (state, { game, statActionName, profileKey = 'current' }) => {
    state.profileStatusMap.statistics[game][profileKey][statActionName] = new Status({ loading: true });
  },

  GET_STAT_SUCCESS: (state, { game, statActionName, stat, stats, profileKey = 'current' }) => {
    state.statistics[game][profileKey][stat] = stats;
    state.profileStatusMap.statistics[game][profileKey][statActionName] = new Status();
  },

  GET_STAT_FAILURE: (state, { game, statActionName, error, profileKey = 'current' }) => {
    state.profileStatusMap.statistics[game][profileKey][statActionName] = new Status({ error });
  },

  GET_PROFILE_COMPONENT_STATS: (state, { game, actionName, profileKey = 'current' }) => {
    // NOTE format example: state.profileStatusMap.statistics.fortnite.opponent.getQueuesStats = new Status();
    state.profileStatusMap.statistics[game][profileKey][actionName] = new Status({ loading: true });
  },

  GET_PROFILE_COMPONENT_STATS_SUCCESS: (state, { gameStats, game, actionName, profileKey = 'current' }) => {
    state.statistics[game][profileKey] = gameStats;
    state.profileStatusMap.statistics[game][profileKey][actionName] = new Status();
  },

  GET_PROFILE_COMPONENT_STATS_FAILURE: (state, { error, game, actionName, profileKey = 'current' }) => {
    state.profileStatusMap.statistics[game][profileKey][actionName] = new Status({ error });
  },

  GET_PROFILE_GENERAL_DATA: (state, { profileKey }) => {
    state.profileStatusMap.general[profileKey] = new Status({ loading: true });
  },

  GET_PROFILE_GENERAL_DATA_SUCCESS: (state, { profileData, profileKey }) => {
    state.general[profileKey] = profileData;
    state.profileStatusMap.general[profileKey] = new Status();
  },

  GET_PROFILE_GENERAL_DATA_FAILURE: (state, { error, profileKey }) => {
    state.profileStatusMap.general[profileKey] = new Status({ error });
  },

  SET_CURRENT_BOOM_ID: (state, { boomAccountId }) => {
    state.currentBoomId = boomAccountId;
  },

  SET_OPPONENT_BOOM_ID: (state, { boomAccountId }) => {
    state.opponentBoomId = boomAccountId;
  },

  RESET_OPPONENT: (state) => {
    state.general.opponent = null;
    availableGames.forEach(game => {
      state.statistics[game].opponent = null;
    });
  },

  GET_LEADERBOARD: (state, { game, options }) => {
    state.statistics[game].leaderboard.selectedFilters = { ...options };
    state.profileStatusMap.statistics[game].leaderboard.getLeaderboard = new Status({ loading: true });
  },

  GET_LEADERBOARD_SUCCESS: (state, { game, list, current, newOffset }) => {
    state.statistics[game].leaderboard.list = list;
    state.statistics[game].leaderboard.current = current;
    state.statistics[game].leaderboard.offset = newOffset;
    state.profileStatusMap.statistics[game].leaderboard.getLeaderboard = new Status();
  },

  GET_LEADERBOARD_FAILURE: (state, { game, error }) => {
    state.profileStatusMap.statistics[game].leaderboard.getLeaderboard = new Status({ error });
  },

  GET_MORE_LEADERBOARD: (state, { game }) => {
    state.profileStatusMap.statistics[game].leaderboard.getMoreLeaderboard = new Status({ loading: true });
  },

  GET_MORE_LEADERBOARD_SUCCESS: (state, { game, list, newOffset }) => {
    state.statistics[game].leaderboard.list = state.statistics[game].leaderboard.list.concat(list);
    state.statistics[game].leaderboard.offset = newOffset;
    state.profileStatusMap.statistics[game].leaderboard.getMoreLeaderboard = new Status();
  },

  GET_MORE_LEADERBOARD_FAILURE: (state, { game, error }) => {
    state.profileStatusMap.statistics[game].leaderboard.getMoreLeaderboard = new Status({ error });
  },

  SEARCH_PLAYERS: (state, { game }) => {
    state.profileStatusMap.statistics[game].compare.searchPlayers = new Status({ loading: true });
  },

  SEARCH_PLAYERS_SUCCESS: (state, { game, playerList }) => {
    state.statistics[game].compare.playerList = playerList;
    state.profileStatusMap.statistics[game].compare.searchPlayers = new Status();
  },

  SEARCH_PLAYERS_FAILURE: (state, { game, error }) => {
    state.profileStatusMap.statistics[game].compare.searchPlayers = new Status({ error });
  },

  GET_COMPARE_LEADERBOARD: (state, { game }) => {
    state.profileStatusMap.statistics[game].compare.searchPlayers = new Status({ loading: true });
  },

  GET_COMPARE_LEADERBOARD_SUCCESS: (state, { game, list }) => {
    state.statistics[game].compare.playerList = list;
    state.profileStatusMap.statistics[game].compare.searchPlayers = new Status();
  },

  GET_COMPARE_LEADERBOARD_FAILURE: (state, { game, error }) => {
    state.profileStatusMap.statistics[game].compare.searchPlayers = new Status({ error });
  },
};
